var addLeadingZero = function(num, pad) {
  return (num.toString().length < pad)? "0" + num.toString(): num;
}

export default addLeadingZero;